<template lang="pug">
li(
  class="nav-item"
  :class="{ 'nav-item_wide': wide }"
  @mouseleave="!checkMobile.any ? mouseLeave($event) : ''"
  @mouseover="!checkMobile.any ? mouseEnter($event) : ''"
  v-click-outside="onClickOutside"
)
  ext-link(
    class="nav-item-link"
    :class="{ 'nav-item-link_big': wide, 'nav-item-link_sublist': showSubList }"
    :style="sectionMenuStyle"
    :to="to"
    :prevent-default="needPrevent"
    :external="external"
    :target="target"
    @click="click"
  )
    span.nav-item-link-text(
      :class="{ multiline: Array.isArray(text) && text.length > 1 }"
      v-html="textOut"
    )

  sub-list(
    v-if="items && items.length && showSubList"
    class="sublist"
    :items="items"
    :level="Number(this.level) + 1"
    :max-level="maxLevel"
  )
    div(v-if="checkMobile.mobile", slot="subListMobile")
      span.top-level-btn(@click="showSubList = false")
      ext-link(
        class="nav-item-link"
        :to="to"
      )
        span.nav-item-link-text(v-html="textOut")
</template>

<script>
import Vue from 'vue';
import ExtLink from '@/components/ext/Link.vue';
import SubList from './SubList.vue';
import checkMobile from '@/mixins/checkMobile';
import colorSectionMenu from '@/mixins/colorSectionMenu';

export default {
  mixins: [checkMobile, colorSectionMenu],
  components: {
    ExtLink,
    SubList,
  },
  data() {
    return {
      extClick: false,
      showSubList: false,
      timer: null,
    };
  },
  props: {
    text: String | Array,
    to: String | Object,
    callback: Function,
    external: Boolean,
    target: {
      type: String,
      default: '_self',
    },
    items: Array,
    level: Number,
    maxLevel: Number,
    wide: Boolean,
  },
  computed: {
    textOut() {
      return Array.isArray(this.text) ? this.text.join('<br/>') : this.text;
    },
    hasChildren() {
      return (
        Array.isArray(this.items) &&
        this.items.length &&
        (this.maxLevel === undefined || this.nextLevel <= this.maxLevel)
      );
    },
    needPrevent() {
      return this.checkMobile.any && !this.extClick;
    },
    styles() {
      const { $store } = this;
      if (!$store || !$store.state.regionProfile) {
        return false;
      }
      const { colorMenuSection } = $store.state.regionProfile;
      return colorMenuSection
        ? {
            backgroundColor: `#${colorMenuSection}`,
            borderColor: `#${colorMenuSection}`,
          }
        : false;
    },
  },

  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = null;
  },

  methods: {
    onClickOutside($event) {
      const {
        checkMobile: { mobile, tablet },
        dataState,
      } = this;
      const { className } = $event.target;
      if (
        (className !== 'nav-menu-mobile-bar' &&
          className !== 'nav-item-link-text' &&
          mobile) ||
        tablet
      ) {
        dataState(false);
      }
    },
    click($event) {
      this.timer = setTimeout(() => {
        if (!this.extClick && !this.checkMobile.mobile) {
          this.dataState(true);
        }
        if (this.checkMobile.mobile) {
          this.showSubList = true;
        }
      }, 50);
    },
    mouseEnter() {
      this.showSubList = true;
    },
    mouseLeave() {
      this.showSubList = false;
    },
    dataState(state) {
      this.showSubList = state;
      this.extClick = state;
    },
  },
  watch: {
    'checkMobile.windowWidth'() {
      this.dataState(false);
    },
    $route() {
      this.dataState(false);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/stylus/helpers/mediaqueriesStep'

$height = 35px
$border = 2px
$lineHeight = $height - 2 * $border - 0px

.nav-item
  position: relative

.nav-item_wide
  width: 100%

.nav-item-link
  padding: 0 8px
  font-size: 11px
  text-decoration: none
  width: 100%
  display: table
  line-height: 13px
  height: $height
  color: #fff
  background: 0 0
  background-color: #6e6bce
  text-align: center
  vertical-align: middle
  border: $border solid #6e6bce
  font-family: Roboto, sans-serif
  font-weight: 700
  text-transform: uppercase
  &.router-link-active
    border-color: #69be63 !important
    background-color: #69be63 !important
  &_sublist,
  &_sublist.router-link-active,
  &.router-link-active:hover,
  &:hover
    background-color: #8593e9 !important
    border-color: #8593e9 !important


.nav-item-link_big
  font-size: 12px
  border-radius: 2px

.nav-item-link-text
  vertical-align: middle
  display: table-cell

.top-level-btn
  display: none
  +phone()
    display: block;
    position: absolute;
    cursor: pointer
    width: 36px;
    height: 36px;
    background: url(./img/arrow.png) 50% no-repeat;
    background-size: 40%;
    color: #5a58ad;
    top: 10px;
    right: 10px;
    font-size: 30px;
    line-height: 36px;
    text-align: center;
</style>



// WEBPACK FOOTER //
// Item.vue?398fb58b